<h2 mat-dialog-title class="text-lg font-semibold text-slate-900">
  Student Transfer
  <span *ngIf="data.studentName" class="text-sm font-normal text-slate-500"> — {{ data.studentName }}</span>
</h2>

<div mat-dialog-content>
  <form [formGroup]="transferForm" class="flex flex-col gap-3 py-2">

    <div>
      <label class="block text-sm font-medium text-slate-700 mb-1">To Institute</label>
      <select formControlName="toInstituteId"
        class="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400">
        <option value="" disabled>Select Institute</option>
        <option *ngFor="let inst of institutes" [value]="inst.id">{{ inst.name }}</option>
      </select>
    </div>

    <div>
      <label class="block text-sm font-medium text-slate-700 mb-1">To Course</label>
      <select formControlName="toCourseId"
        class="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400">
        <option value="" disabled>Select Course</option>
        <option *ngFor="let course of courses" [value]="course.id">{{ course.title || course.name }}</option>
      </select>
    </div>

    <div>
      <label class="block text-sm font-medium text-slate-700 mb-1">To Batch</label>
      <select formControlName="toBatchId"
        class="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400">
        <option value="" disabled>Select Batch</option>
        <option *ngFor="let batch of batches" [value]="batch.id">{{ batch.name || batch.sessionName || batch.startDate }}</option>
      </select>
    </div>

    <div>
      <label class="block text-sm font-medium text-slate-700 mb-1">Reason</label>
      <textarea formControlName="reason" rows="2" placeholder="Enter reason for transfer"
        class="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"></textarea>
    </div>

  </form>
</div>

<div mat-dialog-actions align="end" class="gap-3">
  <button mat-button (click)="onCancel()" class="px-4 py-2 rounded-lg text-slate-600 hover:bg-slate-100">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="transferForm.invalid"
    class="px-4 py-2 rounded-lg text-white bg-gradient-primary hover:bg-gradient-primary-hover">
    Transfer
  </button>
</div>
